import { CenteredBox, H1, H4 } from '../widgets'
import { useBackground, useShell } from '../layout'
import './RegisterSplash.scss'

export const RegisterSplash = ({ active }) => {
  useShell({ active, mode: 'logo' })
  useBackground().set(mobile => ({ active, background: 1, size: mobile ? '500%' : '2072px 2035px', position: mobile ? 'center -300px' : '94px 0', fade: true }))

  return (
    <CenteredBox
      column
      fullWidth
      fullHeight
      gap={32}
      className="register-splash"
    >
      <H1>Thank you<br/>for playing!</H1>
      <H4>
        Ready to see your personalized results? <br/>Join our launch waiting list now and receive 50% off your first year!
      </H4>
    </CenteredBox>
  )
}